var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAdminDLayer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-admin-d-layer-a",
    x1: "25.937%",
    x2: "58.065%",
    y1: "38.341%",
    y2: "69.515%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A8B9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-admin-d-layer-b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DFE5F0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7EEFB",
    d: "M33.6,7 C35.2568542,7 36.6,8.34314575 36.6,10 L36.599,17 L14,17 C12.4023191,17 11.0963391,18.24892 11.0050927,19.8237272 L11,20 L11,33 L6,33 C4.34314575,33 3,31.6568542 3,30 L3,10 C3,8.34314575 4.34314575,7 6,7 L33.6,7 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.6,
    height: 24,
    x: 11,
    y: 17,
    stroke: "url(#ic-admin-d-layer-a)",
    strokeWidth: 2,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 22)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 5,
    r: 4,
    stroke: "#BBC5D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-admin-d-layer-b)",
    fillRule: "nonzero",
    d: "M9,9 C13.9705627,9 18,13.0294373 18,18 L18,18 L16,18 C16,14.2145483 12.9952166,11.1309013 9.24064975,11.004059 L9.24064975,11.004059 L9,11 C5.13400675,11 2,14.1340068 2,18 L2,18 L0,18 C0,13.0294373 4.02943725,9 9,9 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdminDLayer);
export default __webpack_public_path__ + "static/media/ic-admin-d-layer.e0be6c1190af32a7a63a63c13d0cd029.svg";
export { ForwardRef as ReactComponent };